import axios from 'axios'
import React from 'react'
import './Snippet.scss'
import domain from '../../util/domain'

function Snippet({ snippet, getSnippets, editSnippet }) {
    

    async function deleteSnippet() {
        if(window.confirm("Are you sure you want to delete?"))
        await axios.delete(`${domain}/snippet/${snippet._id}`)
        getSnippets()
    }
    return (
        <div className="snippet">
                    <h1 className="title">{snippet.title}</h1>
                    <p className="description">{snippet.description}</p>
                    <pre className="code">
                        <code>{snippet.code}</code>
                    </pre>
                    <button className= 'btn-edit' onClick={()=> editSnippet(snippet)}>Edit</button>
                    <button className='btn-delete' onClick={deleteSnippet}>Delete</button>
        </div>
    )
}

export default Snippet
